const defaultLocale = 'en';
const languages = {
  cs: 'Česky',
  en: 'English',
  hu: 'Magyar',
  pl: 'Polski',
  ro: 'Românesc',
  sk: 'Slovensky',
  de: 'Deutsch',
  uk: 'Український',
};
const namespaces = ['account', 'common', 'forms', 'pages'];
const storage = 'sizeid-language';
const shortLocale = language => language.substr(0, 2);

const locales = Object.keys(languages);
const webLocales = locales.filter(item => item !== 'uk');

const translation = {
  defaultLocale,
  languages,
  namespaces,
  storage,
  shortLocale,
  locales,
  webLocales,
};

module.exports = translation;
